// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"e006e0d6","99":"a843f338"}[chunkId] + ".css";
};